var $a385f3910feda499$exports = {};
$a385f3910feda499$exports = {
  "longPressMessage": "Nor\u0117dami atidaryti meniu, nuspaud\u0119 palaikykite arba paspauskite \u201EAlt + ArrowDown\u201C."
};
export { $a385f3910feda499$exports as default };